<template>
  <SortIcon :class="['sort', direction]" />
</template>

<script>
import SortIcon from '@/components/icons/sort'

/**
 * ソートボタン
 */
export default {
  name: 'SortButton',
  components: {
    SortIcon,
  },
  props: {
    /** ソートの向き `up, down` */
    direction: String,
  },
}
</script>

<style lang="postcss" scoped>
.sort {
  fill: var(--dark-gray);

  &.up {
    >>> .up {
      fill: var(--white);
    }
  }

  &.down {
    >>> .down {
      fill: var(--white);
    }
  }
}
</style>
